import { BusinessUnitSearchComponentBase } from './business-unit-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-business-unit-search',
  templateUrl: './business-unit-search.component.html',
  styleUrls: ['./business-unit-search.component.scss']
})
export class BusinessUnitSearchComponent extends BusinessUnitSearchComponentBase {

  displayedColumns: string[] = ['buId', 'name', 'acronym', 'type', 'territorial', 'closed', 'actions'];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, businessUnitService, refCodeStorage, fb, formStorage, injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.closedFilter = false;
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.typeLoadSelectionList();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}



